<template>
  <div class="check-metrics-page">
    <div class="metrics-box" v-if="!showMatrixconstant">
      <div class="title">
        <h2>Abbiamo trovato queste informazioni sul tuo sito. <span style="color: #2e4eed;">Verifica che siano
            corrette</span> prima di proseguire.</h2>
      </div>
      <div class="metric-item" v-for="(flag, key) in sessionstoreFlags" :key="key">
        <span>{{ key }}:</span>
        <span class="yes-no">
          <input type="checkbox" v-model="sessionstore[flag]" :true-value="true" :false-value="false" />
        </span>
      </div>
    </div>
    <ButtonTemplate v-if="sessionstore.instagramDataLoaded" :button-text="'Conferma'" @click="handleMetricsConfirmation"
      class="confirm-button" />
  </div>
</template>


<script>
import ButtonTemplate from '@/components/widgets/button.vue';
import { config } from '@/config';
import { supabase } from '@/lib/supabaseClient';
import { useSessionStore } from '@/stores/sessionStore';
import axios from 'axios';

export default {
  name: 'CheckMetrics',
  components: {
    ButtonTemplate
  },
  setup() {
    const sessionstore = useSessionStore()
    return {
      sessionstore
    }
  },
  data() {
    return {
      showMatrixconstant: false,
      storytellingScore: 0,
      experienceScore: 0,
      communityScore: 0,
      sessionstoreFlags: {
        'Sezione contatti nel sito': 'flag_contacts_section',
        'Newsletter': 'flag_newsletter',
        'Sito multilingue': 'flag_multilingual',
        'Negozio fisico': 'flag_physical_store',
        'Login sul sito': 'flag_login_option',
        'Negozio online': 'flag_online_shop'
      }
    }
  },
  methods: {
    async handleMetricsConfirmation() {

      await this.writeMetrics();
      // Compute scores after metrics are written to Supabase
      await this.computeScores();

    },
    showMatrix() {
      this.showMatrixconstant = true;
    },

    async writeMetrics() {
      // writes metrics to Supabase, using sessionstore data
      console.log('Writing metrics to Supabase...');
      const { error } = await supabase
        .from('sessions')
        .update(this.sessionstore.getMetrics)
        .eq('session_id', this.sessionstore.session_id);

      if (error) throw error;
    },
    // Method to compute the experience score
    async computeExperienceScore() {
      try {
        console.log('Computing experience score...');
        const pathExp = config.API_BASE_URL + '/compute-experience';
        const requestData = this.sessionstore.getMetrics;

        console.log('inputs', requestData);
        console.log('inputs', this.sessionstore.company_name);

        const { data } = await axios.post(pathExp, {
          website_flags: requestData,
          company_name: this.sessionstore.company_name,
        });

        console.log('data experience', data);

        if (data.status_code !== 200) {
          console.error('Error computing experience score:', data.error);
          this.experienceScore = 0;
          this.sessionstore.experienceError = data.error ?? 'An unknown error occurred while computing the experience score.';
          this.sessionstore.setScore('experience', {
            experience_score: 0,
            exp_flags_score: 0,
            exp_google_maps_review: 0,
          });
          return;
        }

        this.experienceScore = data.score.experience_score;
        this.sessionstore.setScore('experience', data.score);
        console.log('Experience score computed:', this.experienceScore);

        return;
      } catch (error) {
        console.error('Error computing experience score:', error);
        this.experienceScore = 0;
        this.sessionstore.experienceError = error.message ?? 'An unknown error occurred while computing the experience score.';
        this.sessionstore.setScore('experience', {
          experience_score: 0,
          exp_flags_score: 0,
          exp_google_maps_review: 0,
        });
        return;
      }
    },

    /**
     * Computes the storytelling score and updates the sessionstore with the score.
     * 
     * @returns {Promise<void>} A promise that resolves when the storytelling score is computed.
     */
    async computeStorytellingScore() {
      try {
        console.log('Computing storytelling score...');
        const pathStory = config.API_BASE_URL + '/compute-storytelling';


        const { data } = await axios.post(pathStory, {
          company_id: this.sessionstore.company_id,
        });

        if (data.status_code !== 200) {
          console.error('Error computing storytelling score:', data.error);
          this.storytellingScore = 0;
          this.sessionstore.storytellingError = data.error ?? 'An unknown error occurred while computing the storytelling score.';
          this.sessionstore.setScore('storytelling', {
            storytelling_score: 0,
            stlg_frequency_score: 0,
            stlg_share_score: 0,
            stlg_coherence_score: 0,
            stlg_reasoning: '',
          });
          return;
        }

        this.storytellingScore = data.score.storytelling_score;
        this.sessionstore.setScore('storytelling', data.score);
        console.log('Storytelling score computed:', this.storytellingScore);
      } catch (error) {
        console.error('Error computing storytelling score:', error);
        this.storytellingScore = 0;
        this.sessionstore.storytellingError = error.message ?? 'An unknown error occurred while computing the storytelling score.';
        this.sessionstore.setScore('storytelling', {
          storytelling_score: 0,
          stlg_frequency_score: 0,
          stlg_share_score: 0,
          stlg_coherence_score: 0,
          stlg_reasoning: '',
        });
        return;
      }
    },

    // Method to compute the community score
    async computeCommunityScore() {
      try {
        console.log('Computing community score...');

        const pathComm = config.API_BASE_URL + '/compute-community';

        const { data } = await axios.post(pathComm, {
          company_id: this.sessionstore.company_id
        });

        this.communityScore = data?.community_score ?? 0; // Fallback to 0 if undefined
        this.sessionstore.setScore('community', data);
        console.log('Community score data:', data);

        console.log('Community score computed:', this.communityScore);
      } catch (error) {
        console.error('Error computing community score:', error);
        this.communityScore = 0;
      }
    },

    // Main method to compute all scores and update them in the database
    async computeScores() {
      this.$emit('click-metrics-confirm-button');

      // Compute each score individually
      await this.computeExperienceScore();
      await this.computeStorytellingScore();
      await this.computeCommunityScore();

      // After all computations, update the scores in the Supabase session table
      try {
        const { error } = await supabase
          .from('sessions')
          .update({
            status: 'completed',
            storytelling_score: this.sessionstore.storytellingScore,
            stlg_frequency_score: this.sessionstore.stlgFrequencyScore,
            stlg_share_score: this.sessionstore.stlgShareScore,
            stlg_coherence_score: this.sessionstore.stlgCoherenceScore,
            stlg_reasoning: this.sessionstore.stlgReasoning,
            community_score: this.sessionstore.communityScore,
            comm_tagged_time_diff_score: this.sessionstore.commTaggedTimeDifferenceScore,
            comm_engage_rate_benchmark: this.sessionstore.commEngageRateBenchmark,
            comm_like_median_score: this.sessionstore.commLikeMedianScore,
            experience_score: this.sessionstore.experienceScore,
            exp_flags_score: this.sessionstore.expFlagsScore,
            exp_google_maps_review: this.sessionstore.expGoogleMapsReview,
          })
          .eq('session_id', this.sessionstore.session_id);

        if (error) {
          console.error('Error updating scores in Supabase:', error);
        } else {
          console.log('Scores updated successfully in Supabase');
        }
      } catch (error) {
        console.error('Error during Supabase update:', error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.check-metrics-page {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 100vh;
  padding: 2rem;
  width: 100%;
}

.title {
  text-align: center;
  margin-bottom: 2rem;
}

.title h2 {
  color: #1a1a1a;
  font-size: 1.5rem;
  font-weight: 600;
}

.metrics-box {
  background: rgba(255, 255, 255, 0.95);
  padding: 2rem;
  border: 2px solid #2e4eed;
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.metric-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0;
  border-bottom: 1px solid rgba(46, 78, 237, 0.1);
}

.metric-item:last-child {
  border-bottom: none;
}

.metric-item span:first-child {
  color: #1a1a1a;
  font-weight: 500;
}

.yes-no {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.yes-no input[type="checkbox"] {
  width: 1.2rem;
  height: 1.2rem;
  border: 2px solid #2e4eed;
  cursor: pointer;
  margin: 0;
}

.confirm-button {
  margin-top: 2rem;
  --button-border-color: #2e4eed;
  --button-text-color: #ffffff;
  --button-background-color: #2e4eed;
  --button-background-hover-color: #1e3ed8;
  --button-border-radius: 0;
  width: 100%;
  max-width: 500px;
}

@media (max-width: 768px) {
  .check-metrics-page {
    padding: 1rem;
  }

  .metrics-box {
    padding: 1.5rem;
  }

  .title h2 {
    font-size: 1.25rem;
  }
}
</style>
